module.exports = "/_next/static/images/photoConstantinCeban-09a51e4a6861cd6a0cc785e67df8c354.webp";